<ion-header class="app-inner-padding ion-no-border">
	<div>{{ 'login.auth.header' | translate }}</div>
</ion-header>
<div class="app-inner-padding inner-content">
	<form [formGroup]="authForm" role="form" autocomplete="off">
		<ion-item class="label">
			<ion-label>{{ 'login.username' | translate }}</ion-label>
		</ion-item>
		<ion-item>
			<ion-input formControlName="usernameControl" type="text"></ion-input>
		</ion-item>
		<ion-item class="label">
			<ion-label>{{ 'login.password' | translate }}</ion-label>
		</ion-item>
		<ion-item>
			<ion-input formControlName="passwordControl" [type]="showPassword ? 'text' : 'password'"></ion-input>
			<span
				class="icon"
				[ngClass]="{ 'no-show': !showPassword, show: showPassword }"
				(click)="toggleFieldTextType()"
			></span>
		</ion-item>
	</form>
</div>
<ion-footer class="app-inner-padding ion-no-border">
	<ion-button
		data-cy="saveButton"
		class="login-button ion-no-padding ion-no-margin"
		expand="block"
		[disabled]="!authForm.valid"
		fill="clear"
		type="submit"
		(click)="onSubmit(authForm.value)"
	>
		{{ 'login.buttons.submit' | translate }}
	</ion-button>
</ion-footer>
